const DOMPURIFY_CONFIG = {
  ALLOWED_TAGS: [
    'p', 'br', 'b', 'i', 'u', 'strong', 'em', 'span', 'div',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'ul', 'ol', 'li',
    'table', 'thead', 'tbody', 'tr', 'th', 'td',
    'a', 'img', 'blockquote', 'code', 'pre', 'hr',
    'figure', 'figcaption'
  ],
  ALLOWED_ATTR: [
    'href', 'src', 'alt', 'title', 'class', 'id',
    'width', 'height', 'target', 'rel', 'style',
    // Table cell spans — safe, non-scriptable; required for merged-cell tables to render.
    'colspan', 'rowspan',
    'border', 'cellpadding', 'cellspacing'


  ],
  FORBID_TAGS: ['style', 'script', 'iframe', 'object', 'embed', 'form', 'input', 'textarea', 'select'],
  ALLOW_DATA_ATTR: false,
  ADD_ATTR: ['rel'],
} as const;

let sanitizer: ((html: string) => string) | null = null;

export { DOMPURIFY_CONFIG };

export function sanitizeHtml(html: string): string {
  if (!html) return '';

  if (!sanitizer) {
    const DOMPurify = require('dompurify');
    sanitizer = (h: string) => DOMPurify.sanitize(h, DOMPURIFY_CONFIG);
  }

  return sanitizer(html);
}
